"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fieldProps = {
  name: _propTypes["default"].string,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].object, _propTypes["default"].array, _propTypes["default"].number]),
  onChange: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  valid: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  invalid: _propTypes["default"].bool,
  touched: _propTypes["default"].bool,
  pristine: _propTypes["default"].bool,
  dirty: _propTypes["default"].bool,
  visited: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  /** Redux-Form 7 input prop */
  input: _propTypes["default"].object,
  /** Redux-Form 7 meta prop */
  meta: _propTypes["default"].object,
  /** Redux-Form 5 field prop */
  field: _propTypes["default"].object
};
var _default = exports["default"] = fieldProps;